export default "__VITE_ASSET__gaGXMi8t__"